export default function getResource(label, vars = []) {
    const resources = {
        addToBasketShort: 'Ajouter',
        remove: 'Supprimer',
        joinToAccess: 'Join',
        signInToAccess: 'Login',
        exclusive: 'Exclusivement'
    };
    return resources[label];
}
